module.exports = (__parcel__import__("2CK2W")).then(() => parcelRequire('4MKVl'));